import type { FaireProductEntity } from "../../entity_types/product";

export const p_hthdxesrat: FaireProductEntity = {
  token: "p_hthdxesrat",
  type: "product",
  name: "So Very Blessed Cross Necklace – Waterproof Gold Chain",
  brandToken: "b_eow5j1bbc8",
  brandName: "Ellison+Young",
  imageUrl:
    "https://cdn.faire.com/fastly/dee217c2fc204b2d66095245d77bb37671c68ca987cc696dff20fbd42c55bb48.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/465e6a885bb5477eae47518e7d1c65e5429b2a35f86c867626b283055111132f.png",
    "https://cdn.faire.com/fastly/7d03af31fa5fec0fa9d26deb77f0b69ca185279eb835e76a2335ff7e3c703b77.png",
    "https://cdn.faire.com/fastly/acacd0fbe5a887473baeab67e6cd1d8fdbe4479247d736b81efcdf07f2ba6e32.png",
    "https://cdn.faire.com/fastly/4c72d4acb587fca5a5617bc4672e2ed77ff28b917af41eb44f2b49875038d7d7.png",
    "https://cdn.faire.com/fastly/067cd9f2f3b02676fd20b4d26de799d4109dca80288c9e469f9b6cd1bcd8c388.jpeg",
    "https://cdn.faire.com/fastly/63f60ff384f5861aa8fa5857fb260ce7f4931c1cd144c662e68a08f82e381d1b.jpeg",
    "https://cdn.faire.com/fastly/1a8ebcaf6773e124489c68f3e6b4a41543fb80c1ceda1c5600e80546dd199e7d.jpeg",
    "https://cdn.faire.com/fastly/b7fafbbaa30f6301a18bded13aa47829af50ec7dcc6ddd35cc3ccc439458aa14.jpeg",
    "https://cdn.faire.com/fastly/d249bffdbf7517f21632f29f77ad6edb556ab5bbc5f8fc3f59531f2d5087c700.jpeg",
  ],
  priceDollars: 9.43,
  description:
    "Adorable small cross necklace has perfect name, So Very Blessed Collection! The cross comes in beautiful colors! It will make your day more bright and blessed!\n\n•16” long chain with a 2” extender\n\n•The gold cross is made with gold plated brass, and the other beautiful colors of cross beads are made from natural stone with enamel finish. \n\n•18k gold plated Stainless Steel chain that is high quality and last long with no tarnish\n\n•Lead and Nickel Free\n\n•Packaged with specially designed card for this beautiful collection\n\n•Made in China",
  tags: [],
  msrpDollars: 26.36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:24.980Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
